import { PlannerBase }   from "../../planner_base";
import { TaskEditorBase } from './base';
import { Global, CellPosition, LineSelectedSchedule, LineSelectedTask }  from "../model";
import watch from "redux-watch";
import isEqual from 'is-equal';
class Indicators extends TaskEditorBase {
  colorcode: string;
  items: Array<CellPosition> = [];
  init(){
    super.init();
    this.watch();
  }
  beforeUnselect(selectedTask: LineSelectedTask){
  }
  beforeSelect(selectedTask: LineSelectedTask){
    this.updateItems(selectedTask);
  }
  updateItems(selectedTask: LineSelectedTask){
    this.items = [];
    if(!selectedTask){ return; }
    this.colorcode = this.getPhaseData(this.getTaskData(selectedTask.taskId).phase_id).colorcode
    let lineData = Global.getLineData(selectedTask.lineId);
    if(!lineData.schedules){ return; }
    for(let i=0;i<lineData.schedules.length;i++){
      let scheduleId = lineData.schedules[i];
      let scheduleData = Global.getScheduleData(scheduleId);
      if(scheduleData.task_id == selectedTask.taskId){
        let pos = new CellPosition(scheduleData.start_time, scheduleData.end_time);
        this.items.push(pos);
      }
    }
  }
  public onChangeStore(newVal, oldVal, objectPath) {
    super.onChangeStore(newVal, oldVal, objectPath)
    let selectedTask: LineSelectedTask = Global.getPlannerData()['selectedTask']
    this.updateItems(selectedTask);
  }
}
riot.mixin('orders.planner.task.indicators', Indicators as riot.TagMixin)
